// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"157":"pages/Game","336":"pages/Home","525":"pages/PreGame"}[chunkId] + "." + {"157":"9699a22e","336":"981632d7","525":"41b52482"}[chunkId] + ".js";
};